import { UPDATE_CUSTOMER_INFO, UPDATE_SALES_ORG_CONFIG } from '@/store/type';
import { CustomerInfoArr, SalesOrgConfig } from '@/types/store/customer';

export const updateCustomerInformation = (newState: CustomerInfoArr = {}) => {
    return {
        type: UPDATE_CUSTOMER_INFO,
        payload: newState
    };
};

export const updateSalesOrgConfigStore = (newState: SalesOrgConfig = {}) => {
    return {
        type: UPDATE_SALES_ORG_CONFIG,
        payload: newState
    };
};
